import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '@shared/services/language';

@Pipe({
  standalone: true,
  name: 'translatePlural',
})
export class TranslatePluralPipe implements PipeTransform {
  private readonly languageService = inject(LanguageService);

  transform(singularKey: string, pluralSuffix: string, count: number, params?: Record<string, unknown>): string {
    let pluralKey: string;
    if (singularKey.includes('.')) {
      const baseKey = singularKey.substring(0, singularKey.lastIndexOf('.'));
      pluralKey = `${baseKey}.${pluralSuffix}`;
    } else {
      pluralKey = pluralSuffix;
    }
    const finalKey = count > 1 ? pluralKey : singularKey;
    const finalParams = { count, ...params };
    return this.languageService.instant(finalKey, finalParams);
  }
}
